var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{ 'text-success': _vm.isPrivate}},[(_vm.isPrivate)?[_vm._v(_vm._s(_vm.$t("travel.yes_private_car")))]:[_vm._v(_vm._s(_vm.$t("travel.no_company_car")))]],2)}
var staticRenderFns = []

export { render, staticRenderFns }